import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Http } from "@angular/http";
import { ErrorHandler } from "../../shared/services/error-handler.service";
import { HttpService } from "../../shared/services/http.service";
import { SessionHandler } from "../../shared/services/session-handler.service";
import { CommonService } from "../../shared/services/common.service";
import { itemClass, itemClassEditManual } from "./itemClass";
import { MdDialog } from "@angular/material";
import { dialogComponent } from "../../dialog/dialog.component";

@Component({
    selector: 'request-add',
    template: require('./return.component.html'),
    styles: [require('./return.component.scss')],
    providers: [HttpService, ErrorHandler, SessionHandler]
})

export class viewRequestReturnComponent {


    userData: any;
    reasonList: any;
    dialogRef;
    requestFormData: any = {}
    showInsertButton: boolean = true;
    invoice_no: any;
    showInvoiceReturn: boolean = false;
    item_list: any = [];
    itemReason = [];
    enableBtn: boolean = false;
    isItem: boolean = false;
    itemLength: number = 0;
    modelNumber: any;
    serialNumber: any;
    quantity: any = "1";
    returnOrder: any;
    listBtnEnable: boolean = false;
    invoiceBtnEnable: boolean = false;
    itemQuantity = [];
    itemQuantityList = [];
    enableItemReason = [];
    manualListValid = [];
    listLoader = [];
    manualListError = [];
    isUpload: boolean = false;
    isManual: boolean = false;
    showField: any = [];
    serialNumberList = [];
    itemError: boolean = false;
    serialNumberInput: any = [];
    showEditSerial = [];
    tempSerialList = [];
    return_reason: any;
    id: any;
    formData: any;
    showManualList: boolean = false;
    isD2CUser=false;
    constructor(private router: Router, private route: ActivatedRoute, private Http: Http, private http: HttpService, private commonService: CommonService, private sessionHandler: SessionHandler,
        private dialog: MdDialog) {

        this.returnOrder = {};
        this.userData = {};
        if (this.http.checkSession()) {
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            this.route.params.subscribe(params => {
                this.id = +params['id'];
            });
            let data = this.commonService.getData();
            console.log(data)
            if (!isNaN(this.id)) {
                if (data && data['returnOrder']) {
                    this.isD2CUser=data.d2C;/**added for  D2c one time address */
                    this.formData = data;
                    this.commonService.changeViewData(this.formData);
                    this.returnOrder = data['returnOrder'];
                    console.log(this.returnOrder)
                    if (this.formData.returnItemUploadFlag == 2 || this.formData.returnItemUploadFlag == 'INVOICE_NUMBER') {
                        this.setReturnData();
                    } else if (this.formData.returnItemUploadFlag == 0 || this.formData.returnItemUploadFlag == 1 || this.formData.returnItemUploadFlag == 'INSERT_MANUAL' || this.formData.returnItemUploadFlag == 'UPLOAD_FILE') {
                        this.setReturnDataManual();
                    }
                    // this.setReturnData();
                } else {
                    this.getRequestDataWithId();
                }
            }
        } else {
            this.http.showSessionError();
        }
    }

    ngOnInit() { }

    public getRequestDataWithId() {
        this.http.getRequest('returnOrder/v1/getReturnOrder?orderId=' + this.id)
            .subscribe(
                res => { this.saveRequestData(res) },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                });
    }

    public saveRequestData(res) {
        if (res.responseStatus == 'Success') {
       //     res.returnReqDto.returnOrder.focOrder=true;
            this.returnOrder = res.returnReqDto.returnOrder;
            console.log(this.returnOrder)
            this.isD2CUser=res.returnReqDto.d2C;/**added for  D2c one time address */
            this.formData = res.returnReqDto;
            this.commonService.changeViewData(this.formData);
            // this.setReturnData();
            if (this.formData.returnItemUploadFlag == 2 || this.formData.returnItemUploadFlag == 'INVOICE_NUMBER') {
                this.setReturnData();
            } else if (this.formData.returnItemUploadFlag == 0 || this.formData.returnItemUploadFlag == 1 || this.formData.returnItemUploadFlag == 'INSERT_MANUAL' || this.formData.returnItemUploadFlag == 'UPLOAD_FILE') {
                this.setReturnDataManual();
            }
        }
        this.http.onEnd();
    }
    
    public getReasonList() {
        this.http.getRequest('tradePartnerDetails/v1/getReasonCode')
            .subscribe(
                res => { this.saveReasonList(res) },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                });
    }

    public saveReasonList(res) {
        if (res && res.items) {
            this.reasonList = res.items;
            this.sessionHandler.saveItem('reasons', JSON.stringify(this.reasonList));
            for (let r in this.reasonList) {
                if (this.returnOrder.reason == this.reasonList[r].reasonCode) {
                    this.return_reason = this.reasonList[r].reason;
                }
            }
        }
        this.http.onEnd();
    }

    public setReturnData() {
        this.reasonList = JSON.parse(this.sessionHandler.getItem('reasons'));
        if (this.reasonList == null || this.reasonList.length < 0) {
            this.getReasonList();
        } else {
            for (let r in this.reasonList) {
                if (this.returnOrder.reason == this.reasonList[r].reasonCode) {
                    this.return_reason = this.reasonList[r].reason;
                }
            }
        }

        if (this.formData.returnItemUploadFlag == 'INSERT_MANUAL' || this.formData.returnItemUploadFlag == '0' || this.formData.returnItemUploadFlag == 0) {
            this.isManual = true;
        } else if (this.formData.returnItemUploadFlag == 'UPLOAD_FILE' || this.formData.returnItemUploadFlag == '1' || this.formData.returnItemUploadFlag == 1) {
            this.isUpload = true;
        } else if (this.formData.returnItemUploadFlag == 'INVOICE_NUMBER' || this.formData.returnItemUploadFlag == '2' || this.formData.returnItemUploadFlag == 2) {
            this.invoice_no = this.returnOrder.invoiceNumber;
            this.showInvoiceReturn = true;
        } else {
            this.isManual = true;
        }
        if (this.returnOrder.items) {
            let returnOrder = [];
            for (let i in this.returnOrder.items) {
                if (this.returnOrder.items[i]['data']) {
                    returnOrder.push(this.returnOrder.items[i]['data']);
                } else {
                    returnOrder.push(this.returnOrder.items[i]);
                }
            }

            this.item_list = returnOrder;
            let serials: any = [];
            let qty: any = [];
            let models: any = [];
            let invoice: any = [];
            let final: any = [];
            let items: any = [];
            let itemList: any = [];
            let itemList1: any = [];

            for (let i in this.item_list) {
                let reason = null;
                serials[i] = [];
                qty[i] = [];
                models[i] = [];
                invoice[i] = [];
                final[i] = [];
                let dummyItems: itemClass[] = [];
                items.push(dummyItems);
                itemList[i] = [];
                itemList1[i] = [];


                if (this.isManual || this.isUpload) {
                    if (this.item_list[i]) {
                        for (let r in this.reasonList) {
                            if (this.item_list[i].reasonCode == this.reasonList[r].reasonCode) {
                                reason = this.reasonList[r].reason;
                            }
                        }
                        if (this.item_list[i].serialNumber) {
                            items[i].push(new itemClass(this.item_list[i].invoiceDocumentID, this.item_list[i].customerMaterialNumber, this.item_list[i].serialNumber, this.item_list[i].itemID, this.item_list[i].invoicedQuantity, reason, true));
                        } else {
                            items[i].push(new itemClass(this.item_list[i].invoiceDocumentID, this.item_list[i].customerMaterialNumber, null, this.item_list[i].itemID, this.item_list[i].invoicedQuantity, reason, true));
                        }
                    }
                } else {
                    for (let j in this.item_list[i]) {
                        if (this.item_list[i][j]) {
                            for (let r in this.reasonList) {
                                if (this.item_list[i][j].reasonCode == this.reasonList[r].reasonCode) {
                                    reason = this.reasonList[r].reason;
                                }
                            }
                            if (this.item_list[i][j].serialNumber) {
                                items[i].push(new itemClass(this.item_list[i][j].invoiceDocumentID, this.item_list[i][j].customerMaterialNumber, this.item_list[i][j].serialNumber, this.item_list[i][j].itemID, this.item_list[i][j].invoicedQuantity, reason, true));
                            } else {
                                items[i].push(new itemClass(this.item_list[i][j].invoiceDocumentID, this.item_list[i][j].customerMaterialNumber, null, this.item_list[i][j].itemID, this.item_list[i][j].invoicedQuantity, reason, true));
                            }
                        }
                    }
                }
            }

            for (let i in items) {
                for (let j in items[i]) {
                    if (models[i].indexOf(items[i][j].modelNumber) == -1) {
                        models[i].push(items[i][j].modelNumber);
                    }
                }
            }

            if (this.invoice_no) {
                for (let i in items) {
                    for (let j in items[i]) {
                        if (invoice[i].indexOf(items[i][j].invoiceDocumentID) == -1) {
                            invoice[i].push(items[i][j].invoiceDocumentID);
                        }
                    }
                }
            }

            if (this.invoice_no) {
                for (let i in models) {
                    for (let j in models[i]) {
                        serials[i][models[i][j]] = [];
                        qty[i][models[i][j]] = 0;
                        for (let k in items) {
                            for (let l in items[k]) {
                                let rawSerial = {};
                                if (invoice[i][0] == items[k][l].invoiceDocumentID) {
                                    if (models[i][j] == items[k][l].modelNumber) {

                                        qty[i][models[i][j]] += parseInt(items[k][l].invoicedQuantity);
                                        if ((items[k][l].serialNumber)) {
                                            rawSerial = items[k][l].serialNumber;
                                        } else {
                                            rawSerial = '';
                                        }
                                        if ((items[k][l].serialNumber)) {
                                            serials[i][models[i][j]].push(rawSerial);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                for (let i in models) {
                    for (let j in models[i]) {
                        serials[i][models[i][j]] = [];
                        qty[i][models[i][j]] = 0;
                        for (let k in items) {
                            for (let l in items[k]) {
                                let rawSerial = {};
                                if (models[i][j] == items[k][l].modelNumber) {
                                    qty[i][models[i][j]] += parseInt(items[k][l].invoicedQuantity);
                                    if ((items[k][l].serialNumber)) {
                                        rawSerial = items[k][l].serialNumber;
                                    } else {
                                        rawSerial = '';
                                    }
                                    if ((items[k][l].serialNumber)) {
                                        serials[i][models[i][j]].push(rawSerial);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (this.invoice_no) {
                for (let m in models) {
                    for (let n in models[m]) {
                        for (let i in items) {
                            for (let j in items[i]) {
                                if (invoice[m][0] == items[i][j].invoiceDocumentID) {
                                    if (models[m][n] == items[i][j].modelNumber) {
                                        final[i][j] = [];
                                        final[i][j] = items[i][j];
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                for (let m in models) {
                    for (let n in models[m]) {
                        for (let i in items) {
                            for (let j in items[i]) {
                                if (models[m][n] == items[i][j].modelNumber) {
                                    final[i][j] = [];
                                    final[i][j] = items[i][j];
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            if (this.invoice_no) {
                for (let f in final) {
                    for (let g in final[f]) {
                        for (let s in serials) {
                            for (let t in serials[s]) {
                                if (final[f][g].invoiceDocumentID == invoice[s][0] && final[f][g].modelNumber == t) {
                                    final[f][g].invoicedQuantity = qty[s][t];
                                    final[f][g].serialNumber = serials[s][t];
                                }
                            }
                        }
                        itemList[f].push(final[f][g]);
                    }
                }
            } else {
                for (let f in final) {
                    for (let g in final[f]) {
                        for (let s in serials) {
                            for (let t in serials[s]) {
                                if (final[f][g].modelNumber == t) {
                                    final[f][g].invoicedQuantity = qty[s][t];
                                    final[f][g].serialNumber = serials[s][t];
                                }
                            }
                        }
                        itemList[f].push(final[f][g]);
                    }
                }
            }

            this.item_list = itemList;
        }
    }

    //FOR MANUAL ENTRIES
    public setReturnDataManual() {
        this.reasonList = JSON.parse(this.sessionHandler.getItem('reasons'));
        if (this.reasonList == null || this.reasonList.length < 0) {
            this.getReasonList();
        } else {
            for (let r in this.reasonList) {
                if (this.returnOrder.reason == this.reasonList[r].reasonCode) {
                    this.return_reason = this.reasonList[r].reason;
                }
            }
        }
        if (this.requestFormData.returnItemUploadFlag == 'INSERT_MANUAL' || this.requestFormData.returnItemUploadFlag == '0' || this.requestFormData.returnItemUploadFlag == 0) {
            this.isManual = true;
        } else if (this.requestFormData.returnItemUploadFlag == 'UPLOAD_FILE' || this.requestFormData.returnItemUploadFlag == '1' || this.requestFormData.returnItemUploadFlag == 1) {
            this.isUpload = true;
        } else if (this.requestFormData.returnItemUploadFlag == 'INVOICE_NUMBER' || this.requestFormData.returnItemUploadFlag == '2' || this.requestFormData.returnItemUploadFlag == 2) {
            this.invoice_no = this.returnOrder.invoiceNumber;
            this.showInsertButton = false;
            this.showInvoiceReturn = true;
        } else {
            this.isManual = true;
        }

        if (this.returnOrder.items) {
            this.item_list = Object.assign([], this.returnOrder.items);
            if (this.item_list && this.item_list.length > 0) {
                if (this.item_list[0].modelNumber) {
                    this.setItemListManual();
                } else {
                    this.setItemDataForEditManual();
                }
            }
        }
        this.showManualList = true;
    }

    public deleteManual(index) {
        this.itemQuantityList.splice(index, 1);
        this.itemQuantity.splice(index, 1);

        this.serialNumberList.splice(index, 1);
        this.serialNumberInput.splice(index, 1);
        this.showEditSerial.splice(index, 1);

        this.itemReason.splice(index, 1);
        this.enableItemReason.splice(index, 1);
        this.item_list.splice(index, 1);
    }

    public setItemListManual() {
        for (let i in this.item_list) {
            if (parseInt(this.item_list[i].invoicedQuantity) > 0) {
                this.enableItemReason[i] = true;
                this.showEditSerial[i] = false;
    
                // Normalized serials container
                this.serialNumberList[i] = [];
    
                // === NEW: normalize serialNumber from various shapes ===
                try {
                    const rawSerial = this.item_list[i].serialNumber;
                    if (rawSerial !== undefined && rawSerial !== null) {
                        // Array case: could be array of strings or array of { value: string } or objects
                        if (Array.isArray(rawSerial)) {
                            rawSerial.forEach(s => {
                                if (typeof s === 'string' && s.trim() !== '') {
                                    this.serialNumberList[i].push({ value: s });
                                } else if (s && (s.value || s.id)) {
                                    // preserve object shape if it already has value
                                    this.serialNumberList[i].push({ value: s.value ? s.value : '' });
                                }
                            });
                        } else if (typeof rawSerial === 'string') {
                            if (rawSerial.trim() !== '') {
                                this.serialNumberList[i].push({ value: rawSerial });
                            }
                        } else if (rawSerial && rawSerial.value) {
                            // single object with value property
                            if (rawSerial.value.trim() !== '') {
                                this.serialNumberList[i].push({ value: rawSerial.value });
                            }
                        }
                    }
                } catch (e) {
                    console.error('Error normalizing serials for item index', i, e);
                }
                // === END normalization ===
    
                if (this.isManual) {
                    this.item_list[i].done = true;
                }
    
                for (let q in this.itemQuantityList[i]) {
                    if (this.itemQuantityList[i][q] == this.item_list[i].invoicedQuantity) {
                        this.itemQuantity[i] = this.itemQuantityList[i][q];
                    }
                }
                let count = 0;
                for (let x in this.serialNumberList[i]) {
                    if (this.serialNumberList[i][x].value && this.serialNumberList[i][x].value != '') {
                        count++;
                    }
                }
                if (count < parseInt(this.item_list[i].invoicedQuantity)) {
                    this.showEditSerial[i] = true;
                }
                if (this.item_list[i].reasonCode) {
                    this.itemReason[i] = this.item_list[i].reasonCode;
                }
            }
        }
    }
    

    public setItemDataForEditManual() {
        console.log(this.item_list);
        if (this.item_list) {
            let serials: any = [];
            let qty: any = [];
            let models: any = [];
            let final: any = [];
            let items: itemClassEditManual[] = [];
            let itemList: any = [];
            for (let i in this.item_list) {
                if (this.item_list[i]) {
                    if (!this.item_list[i].id) {
                        this.item_list[i].id = '';
                    }
                    let reason = null;
                    if (this.item_list[i].reasonCode) {
                        reason = this.item_list[i].reasonCode;
                    }
                    let maxQuantity = '';
                    if (this.item_list[i].maxQuantity && this.item_list[i].maxQuantity != '') {
                        maxQuantity = this.item_list[i].maxQuantity
                    }
                    if (this.item_list[i].serialNumber) {
                        items.push(new itemClassEditManual(this.item_list[i].id, this.item_list[i].customerMaterialNumber, this.item_list[i].serialNumber, this.item_list[i].itemID, reason, this.item_list[i].invoicedQuantity, maxQuantity, true));
                    } else {
                        items.push(new itemClassEditManual(this.item_list[i].id, this.item_list[i].customerMaterialNumber, null, this.item_list[i].itemID, reason, this.item_list[i].invoicedQuantity, maxQuantity, true));
                    }
                }
            }

            for (let i in items) {
                console.log(items);
                if (models.indexOf(items[i].modelNumber) == -1) {
                    models.push(items[i].modelNumber);
                }
            }

            for (let m in models) {
                serials[models[m]] = [];
                qty[models[m]] = 0;
                for (let i in items) {
                    let rawSerial = {};
                    if (models[m] == items[i].modelNumber) {
                        qty[models[m]] = parseInt(items[i].invoicedQuantity);
                        if (items[i].id) {
                            rawSerial['id'] = items[i].id;
                        } else {
                            rawSerial['id'] = '';
                        }
                        if ((items[i].serialNumber)) {
                            rawSerial['value'] = items[i].serialNumber;
                        } else {
                            rawSerial['value'] = '';
                        }
                        serials[models[m]].push(rawSerial);
                    }
                }
            }

            for (let m in models) {
                for (let i in items) {
                    if (models[m] == items[i].modelNumber) {
                        final[i] = [];
                        final[i] = items[i];
                        break;
                    }
                }
            }

            for (let f in final) {
                for (let s in serials) {
                    if (final[f].modelNumber == s) {
                        final[f].invoicedQuantity = qty[s];
                        final[f].serialNumber = serials[s];
                    }
                }
                itemList.push(final[f]);
            }
            this.item_list = items;

            for (let i in this.item_list) {
                this.itemQuantityList[i] = [];
                let loopCount = 0;
                if (this.item_list[i].maxQuantity && this.item_list[i].maxQuantity != '') {
                    loopCount = parseInt(this.item_list[i].maxQuantity);
                } else {
                    loopCount = this.item_list[i].invoicedQuantity;
                }
                for (var x = 0; x <= loopCount; x++) {
                    this.itemQuantityList[i].push(x);
                }
            }
            console.log(this.item_list);
            if (this.item_list && this.item_list.length > 0) {
                this.setItemListManual();
            }
        }
    }
    // END Maual Functions

    public isItemInArray(array, item) {
        for (var i = 0; i < array.length; i++) {
            // This if statement depends on the format of your array
            if (array[i].value == item) {
                return true;   // Found it
            }
        }
        return false;   // Not found
    }

    public goToNextPage() {
        this.commonService.setData(this.formData);
        this.router.navigateByUrl('/app/view/confirm/' + this.id);
    }

    public goToPreviousPage() {
        this.router.navigateByUrl('/app/view/create/' + this.id);
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewRequest/return/return.component.ts